var React = require('react');

function PicSliderArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M67.9982 7.44545C68.0333 8.04581 67.5551 8.55984 66.9302 8.59357C36.9466 10.2119 60.9715 12.4689 3.77652 8.77389L8.67028 14.1981C9.08022 14.6525 9.02911 15.3401 8.55613 15.734C8.08314 16.1278 7.36737 16.0787 6.95741 15.6243L0.276917 8.21962C-0.133018 7.76523 -0.0819241 7.07762 0.391068 6.68379L8.09891 0.266035C8.5719 -0.12779 9.28767 -0.0786945 9.69762 0.375695C10.1076 0.830083 10.0565 1.5177 9.58347 1.91152L3.94939 6.60262C60.0667 10.2857 39.6667 6.85714 66.8031 6.41948C67.428 6.38575 67.9631 6.84509 67.9982 7.44545Z","fill":"#1A1A1A"}));
}

PicSliderArrowLeftInline.defaultProps = {"width":"68","height":"16","viewBox":"0 0 68 16","fill":"none"};

module.exports = PicSliderArrowLeftInline;

PicSliderArrowLeftInline.default = PicSliderArrowLeftInline;
